import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar, Cell } from 'recharts';
const VendorPerformanceDashboard: React.FC = () => {
  const kpis = [{
    title: 'Vendor Rating %',
    value: '92.4%',
    change: '+3.2%',
    isPositive: true,
    subtitle: 'Average vendor score'
  }, {
    title: 'On-time Delivery %',
    value: '89.7%',
    change: '+2.5%',
    isPositive: true,
    subtitle: 'Delivery performance'
  }, {
    title: 'Quality Rejection %',
    value: '1.8%',
    change: '-0.4%',
    isPositive: true,
    subtitle: 'Defect rate'
  }];
  // Vendor Score Radar Chart Data (Top 5 Vendors)
  const radarChartData = [{
    metric: 'Quality',
    'Bharat Forge': 95,
    'Motherson Sumi': 92,
    'Amara Raja': 88,
    'Minda Industries': 90,
    Samvardhana: 87
  }, {
    metric: 'Delivery',
    'Bharat Forge': 93,
    'Motherson Sumi': 89,
    'Amara Raja': 91,
    'Minda Industries': 88,
    Samvardhana: 85
  }, {
    metric: 'Cost',
    'Bharat Forge': 88,
    'Motherson Sumi': 94,
    'Amara Raja': 86,
    'Minda Industries': 90,
    Samvardhana: 92
  }, {
    metric: 'Innovation',
    'Bharat Forge': 91,
    'Motherson Sumi': 87,
    'Amara Raja': 89,
    'Minda Industries': 85,
    Samvardhana: 83
  }, {
    metric: 'Compliance',
    'Bharat Forge': 96,
    'Motherson Sumi': 93,
    'Amara Raja': 94,
    'Minda Industries': 91,
    Samvardhana: 89
  }, {
    metric: 'Service',
    'Bharat Forge': 90,
    'Motherson Sumi': 91,
    'Amara Raja': 87,
    'Minda Industries': 89,
    Samvardhana: 86
  }];
  // Delivery Timeliness Trend Data
  const deliveryTimelinessData = [{
    month: 'Jan',
    onTime: 85.2,
    early: 8.5,
    late: 6.3
  }, {
    month: 'Feb',
    onTime: 86.5,
    early: 9.2,
    late: 4.3
  }, {
    month: 'Mar',
    onTime: 87.8,
    early: 8.8,
    late: 3.4
  }, {
    month: 'Apr',
    onTime: 88.2,
    early: 9.5,
    late: 2.3
  }, {
    month: 'May',
    onTime: 88.9,
    early: 8.9,
    late: 2.2
  }, {
    month: 'Jun',
    onTime: 89.1,
    early: 9.1,
    late: 1.8
  }, {
    month: 'Jul',
    onTime: 89.4,
    early: 9.3,
    late: 1.3
  }, {
    month: 'Aug',
    onTime: 89.7,
    early: 9.2,
    late: 1.1
  }, {
    month: 'Sep',
    onTime: 89.7,
    early: 9.4,
    late: 0.9
  }];
  // Defect PPM by Vendor Data
  const defectPPMData = [{
    vendor: 'Bharat Forge',
    ppm: 125,
    color: '#10b981'
  }, {
    vendor: 'Motherson Sumi',
    ppm: 185,
    color: '#10b981'
  }, {
    vendor: 'Amara Raja',
    ppm: 245,
    color: '#10b981'
  }, {
    vendor: 'Minda Industries',
    ppm: 310,
    color: '#f59e0b'
  }, {
    vendor: 'Samvardhana',
    ppm: 385,
    color: '#f59e0b'
  }, {
    vendor: 'Varroc Engineering',
    ppm: 420,
    color: '#f59e0b'
  }, {
    vendor: 'Gabriel India',
    ppm: 485,
    color: '#f59e0b'
  }, {
    vendor: 'Sona BLW',
    ppm: 545,
    color: '#ef4444'
  }, {
    vendor: 'Endurance Tech',
    ppm: 620,
    color: '#ef4444'
  }, {
    vendor: 'Lumax Industries',
    ppm: 785,
    color: '#ef4444'
  }];
  // Vendor Ranking Table Data
  const vendorRankingData = [{
    rank: 1,
    vendor: 'Bharat Forge',
    category: 'Forging & Casting',
    overallScore: 92.5,
    qualityScore: 95,
    deliveryScore: 93,
    costScore: 88,
    innovationScore: 91,
    complianceScore: 96,
    onTimeDelivery: 93.2,
    defectPPM: 125,
    leadTime: 14,
    annualSpend: 285,
    riskLevel: 'Low',
    trend: 'up'
  }, {
    rank: 2,
    vendor: 'Motherson Sumi',
    category: 'Wiring Harness',
    overallScore: 91.2,
    qualityScore: 92,
    deliveryScore: 89,
    costScore: 94,
    innovationScore: 87,
    complianceScore: 93,
    onTimeDelivery: 89.5,
    defectPPM: 185,
    leadTime: 18,
    annualSpend: 425,
    riskLevel: 'Low',
    trend: 'up'
  }, {
    rank: 3,
    vendor: 'Amara Raja',
    category: 'Batteries',
    overallScore: 89.8,
    qualityScore: 88,
    deliveryScore: 91,
    costScore: 86,
    innovationScore: 89,
    complianceScore: 94,
    onTimeDelivery: 91.2,
    defectPPM: 245,
    leadTime: 16,
    annualSpend: 185,
    riskLevel: 'Low',
    trend: 'stable'
  }, {
    rank: 4,
    vendor: 'Minda Industries',
    category: 'Switches & Sensors',
    overallScore: 88.5,
    qualityScore: 90,
    deliveryScore: 88,
    costScore: 90,
    innovationScore: 85,
    complianceScore: 91,
    onTimeDelivery: 88.7,
    defectPPM: 310,
    leadTime: 20,
    annualSpend: 165,
    riskLevel: 'Medium',
    trend: 'up'
  }, {
    rank: 5,
    vendor: 'Samvardhana',
    category: 'Interior Trim',
    overallScore: 87.2,
    qualityScore: 87,
    deliveryScore: 85,
    costScore: 92,
    innovationScore: 83,
    complianceScore: 89,
    onTimeDelivery: 85.3,
    defectPPM: 385,
    leadTime: 22,
    annualSpend: 145,
    riskLevel: 'Medium',
    trend: 'stable'
  }, {
    rank: 6,
    vendor: 'Varroc Engineering',
    category: 'Lighting Systems',
    overallScore: 86.5,
    qualityScore: 85,
    deliveryScore: 87,
    costScore: 88,
    innovationScore: 86,
    complianceScore: 88,
    onTimeDelivery: 87.2,
    defectPPM: 420,
    leadTime: 19,
    annualSpend: 195,
    riskLevel: 'Medium',
    trend: 'up'
  }, {
    rank: 7,
    vendor: 'Gabriel India',
    category: 'Shock Absorbers',
    overallScore: 85.8,
    qualityScore: 84,
    deliveryScore: 86,
    costScore: 87,
    innovationScore: 84,
    complianceScore: 87,
    onTimeDelivery: 86.5,
    defectPPM: 485,
    leadTime: 21,
    annualSpend: 125,
    riskLevel: 'Medium',
    trend: 'stable'
  }, {
    rank: 8,
    vendor: 'Sona BLW',
    category: 'Gears & Driveline',
    overallScore: 84.2,
    qualityScore: 83,
    deliveryScore: 84,
    costScore: 86,
    innovationScore: 82,
    complianceScore: 86,
    onTimeDelivery: 84.8,
    defectPPM: 545,
    leadTime: 24,
    annualSpend: 215,
    riskLevel: 'High',
    trend: 'down'
  }, {
    rank: 9,
    vendor: 'Endurance Tech',
    category: 'Suspension',
    overallScore: 82.5,
    qualityScore: 81,
    deliveryScore: 82,
    costScore: 84,
    innovationScore: 80,
    complianceScore: 85,
    onTimeDelivery: 82.3,
    defectPPM: 620,
    leadTime: 26,
    annualSpend: 175,
    riskLevel: 'High',
    trend: 'down'
  }, {
    rank: 10,
    vendor: 'Lumax Industries',
    category: 'Lighting',
    overallScore: 80.8,
    qualityScore: 79,
    deliveryScore: 81,
    costScore: 83,
    innovationScore: 78,
    complianceScore: 83,
    onTimeDelivery: 81.5,
    defectPPM: 785,
    leadTime: 28,
    annualSpend: 135,
    riskLevel: 'High',
    trend: 'down'
  }];
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <TrendingUpIcon size={14} className="text-green-600" data-id="element-10182" />;
    if (trend === 'down') return <TrendingDownIcon size={14} className="text-red-600" data-id="element-10183" />;
    return <span className="text-gray-400" data-id="element-10184">—</span>;
  };
  const getRiskColor = (risk: string) => {
    switch (risk) {
      case 'Low':
        return 'bg-green-100 text-green-700';
      case 'Medium':
        return 'bg-yellow-100 text-yellow-700';
      case 'High':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  const getScoreColor = (score: number) => {
    if (score >= 90) return 'text-green-600 bg-green-50';
    if (score >= 85) return 'text-blue-600 bg-blue-50';
    if (score >= 80) return 'text-yellow-600 bg-yellow-50';
    return 'text-red-600 bg-red-50';
  };
  return <div data-id="element-10185">
      <DescriptionPanel title="Vendor Performance & Quality Analysis" description="Comprehensive vendor evaluation across quality, delivery, cost, innovation, and compliance metrics. Monitor vendor ratings, on-time delivery performance, defect rates, and identify improvement opportunities to strengthen supplier relationships." insights={['Average vendor rating at 92.4% - up 3.2% from last quarter with focused improvement programs', 'On-time delivery improved to 89.7% - only 0.9% late deliveries in September', 'Quality rejection rate reduced to 1.8% - down 0.4% through better vendor engagement', 'Bharat Forge leading with 92.5% overall score and lowest defect rate at 125 PPM']} data-id="element-10186" />
      {/* KPIs */}
      <div className="mb-8" data-id="element-10187">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-10188">
          Vendor Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-10189">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-10190">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-10191">
                {kpi.title}
              </div>
              <div className="text-xs text-gray-400 mb-3" data-id="element-10192">{kpi.subtitle}</div>
              <div className="text-4xl font-bold text-gray-900 mb-3" data-id="element-10193">
                {kpi.value}
              </div>
              <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-10194">
                {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-10195" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-10196" />}
                {kpi.change} vs last quarter
              </div>
            </Card>)}
        </div>
      </div>
      {/* Vendor Score Radar Chart and Delivery Timeliness */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-10197">
        {/* Vendor Score Radar Chart */}
        <Card className="p-6" data-id="element-10198">
          <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-10199">
            Vendor Score Radar Chart - Top 5 Vendors
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-10200">
            Multi-dimensional performance comparison
          </p>
          <ResponsiveContainer width="100%" height={400} data-id="element-10201">
            <RadarChart data={radarChartData} data-id="element-10202">
              <PolarGrid stroke="#e5e7eb" data-id="element-10203" />
              <PolarAngleAxis dataKey="metric" tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} data-id="element-10204" />
              <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{
              fontSize: 10
            }} data-id="element-10205" />
              <Radar name="Bharat Forge" dataKey="Bharat Forge" stroke="#3b82f6" fill="#3b82f6" fillOpacity={0.3} strokeWidth={2} data-id="element-10206" />
              <Radar name="Motherson Sumi" dataKey="Motherson Sumi" stroke="#10b981" fill="#10b981" fillOpacity={0.3} strokeWidth={2} data-id="element-10207" />
              <Radar name="Amara Raja" dataKey="Amara Raja" stroke="#f59e0b" fill="#f59e0b" fillOpacity={0.3} strokeWidth={2} data-id="element-10208" />
              <Radar name="Minda Industries" dataKey="Minda Industries" stroke="#8b5cf6" fill="#8b5cf6" fillOpacity={0.3} strokeWidth={2} data-id="element-10209" />
              <Radar name="Samvardhana" dataKey="Samvardhana" stroke="#ef4444" fill="#ef4444" fillOpacity={0.3} strokeWidth={2} data-id="element-10210" />
              <Legend wrapperStyle={{
              fontSize: '11px'
            }} data-id="element-10211" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '12px'
            }} data-id="element-10212" />
            </RadarChart>
          </ResponsiveContainer>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-10213">
            <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-10214">
              <div className="text-center" data-id="element-10215">
                <div className="text-gray-600" data-id="element-10216">Top Vendor</div>
                <div className="text-lg font-bold text-blue-600" data-id="element-10217">
                  Bharat Forge
                </div>
              </div>
              <div className="text-center" data-id="element-10218">
                <div className="text-gray-600" data-id="element-10219">Avg Score</div>
                <div className="text-lg font-bold text-gray-900" data-id="element-10220">90.2</div>
              </div>
              <div className="text-center" data-id="element-10221">
                <div className="text-gray-600" data-id="element-10222">Categories</div>
                <div className="text-lg font-bold text-gray-900" data-id="element-10223">6</div>
              </div>
            </div>
          </div>
        </Card>
        {/* Delivery Timeliness Chart */}
        <Card className="p-6" data-id="element-10224">
          <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-10225">
            Delivery Timeliness Trend
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-10226">
            Monthly delivery performance breakdown (%)
          </p>
          <ResponsiveContainer width="100%" height={400} data-id="element-10227">
            <LineChart data={deliveryTimelinessData} data-id="element-10228">
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-10229" />
              <XAxis dataKey="month" tick={{
              fontSize: 12
            }} data-id="element-10230" />
              <YAxis tick={{
              fontSize: 12
            }} domain={[0, 100]} data-id="element-10231" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }} formatter={(value: number) => `${value.toFixed(1)}%`} data-id="element-10232" />
              <Legend data-id="element-10233" />
              <Line type="monotone" dataKey="onTime" stroke="#10b981" strokeWidth={3} name="On-Time" dot={{
              r: 5
            }} data-id="element-10234" />
              <Line type="monotone" dataKey="early" stroke="#3b82f6" strokeWidth={2} name="Early" dot={{
              r: 4
            }} data-id="element-10235" />
              <Line type="monotone" dataKey="late" stroke="#ef4444" strokeWidth={2} name="Late" dot={{
              r: 4
            }} data-id="element-10236" />
            </LineChart>
          </ResponsiveContainer>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-10237">
            <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-10238">
              <div className="text-center" data-id="element-10239">
                <div className="text-gray-600" data-id="element-10240">On-Time</div>
                <div className="text-xl font-bold text-green-600" data-id="element-10241">89.7%</div>
              </div>
              <div className="text-center" data-id="element-10242">
                <div className="text-gray-600" data-id="element-10243">Early</div>
                <div className="text-xl font-bold text-blue-600" data-id="element-10244">9.4%</div>
              </div>
              <div className="text-center" data-id="element-10245">
                <div className="text-gray-600" data-id="element-10246">Late</div>
                <div className="text-xl font-bold text-red-600" data-id="element-10247">0.9%</div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      {/* Defect PPM by Vendor */}
      <Card className="p-6 mb-8" data-id="element-10248">
        <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-10249">
          Defect PPM by Vendor - Top 10
        </h3>
        <p className="text-sm text-gray-600 mb-4" data-id="element-10250">
          Parts per million defect rate (lower is better)
        </p>
        <ResponsiveContainer width="100%" height={350} data-id="element-10251">
          <BarChart data={defectPPMData} layout="vertical" data-id="element-10252">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-10253" />
            <XAxis type="number" tick={{
            fontSize: 12
          }} data-id="element-10254" />
            <YAxis dataKey="vendor" type="category" width={130} tick={{
            fontSize: 11
          }} data-id="element-10255" />
            <Tooltip contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px'
          }} formatter={(value: number) => `${value} PPM`} data-id="element-10256" />
            <Bar dataKey="ppm" name="Defect PPM" data-id="element-10257">
              {defectPPMData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-10258" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-10259">
          <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-10260">
            <div className="text-center" data-id="element-10261">
              <div className="text-gray-600" data-id="element-10262">Best Performance</div>
              <div className="text-lg font-bold text-green-600" data-id="element-10263">125 PPM</div>
              <div className="text-xs text-gray-500" data-id="element-10264">Bharat Forge</div>
            </div>
            <div className="text-center" data-id="element-10265">
              <div className="text-gray-600" data-id="element-10266">Average PPM</div>
              <div className="text-lg font-bold text-gray-900" data-id="element-10267">410 PPM</div>
            </div>
            <div className="text-center" data-id="element-10268">
              <div className="text-gray-600" data-id="element-10269">Target PPM</div>
              <div className="text-lg font-bold text-blue-600" data-id="element-10270">250 PPM</div>
            </div>
            <div className="text-center" data-id="element-10271">
              <div className="text-gray-600" data-id="element-10272">Vendors Below Target</div>
              <div className="text-lg font-bold text-green-600" data-id="element-10273">3/10</div>
            </div>
          </div>
        </div>
      </Card>
      {/* Vendor Ranking Table */}
      <Card className="p-6" data-id="element-10274">
        <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-10275">
          Comprehensive Vendor Ranking - Top 10
        </h3>
        <div className="overflow-x-auto" data-id="element-10276">
          <table className="w-full" data-id="element-10277">
            <thead data-id="element-10278">
              <tr className="border-b-2 border-gray-300" data-id="element-10279">
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10280">
                  Rank
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10281">
                  Vendor
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10282">
                  Category
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10283">
                  Overall Score
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10284">
                  Quality
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10285">
                  Delivery
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10286">
                  Cost
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10287">
                  Innovation
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10288">
                  Compliance
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10289">
                  OTD %
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10290">
                  Defect PPM
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10291">
                  Lead Time
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10292">
                  Annual Spend
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10293">
                  Risk Level
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-10294">
                  Trend
                </th>
              </tr>
            </thead>
            <tbody data-id="element-10295">
              {vendorRankingData.map((row, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-10296">
                  <td className="py-3 px-4 text-center" data-id="element-10297">
                    <div className={`inline-flex items-center justify-center w-8 h-8 rounded-full font-bold text-sm ${row.rank <= 3 ? 'bg-gradient-to-br from-yellow-400 to-yellow-600 text-white' : 'bg-gray-200 text-gray-700'}`} data-id="element-10298">
                      {row.rank}
                    </div>
                  </td>
                  <td className="py-3 px-4 text-sm font-semibold text-gray-800" data-id="element-10299">
                    {row.vendor}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-10300">
                    {row.category}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-10301">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-bold ${getScoreColor(row.overallScore)}`} data-id="element-10302">
                      {row.overallScore.toFixed(1)}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10303">
                    {row.qualityScore}
                  </td>
                  <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10304">
                    {row.deliveryScore}
                  </td>
                  <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10305">
                    {row.costScore}
                  </td>
                  <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10306">
                    {row.innovationScore}
                  </td>
                  <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10307">
                    {row.complianceScore}
                  </td>
                  <td className="py-3 px-4 text-center text-sm font-medium text-green-600" data-id="element-10308">
                    {row.onTimeDelivery.toFixed(1)}%
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-10309">
                    <span className={`text-sm font-bold ${row.defectPPM < 250 ? 'text-green-600' : row.defectPPM < 500 ? 'text-yellow-600' : 'text-red-600'}`} data-id="element-10310">
                      {row.defectPPM}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10311">
                    {row.leadTime}d
                  </td>
                  <td className="py-3 px-4 text-right text-sm font-medium text-blue-600" data-id="element-10312">
                    ₹{row.annualSpend} Cr
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-10313">
                    <span className={`inline-flex px-3 py-1 rounded-full text-xs font-bold ${getRiskColor(row.riskLevel)}`} data-id="element-10314">
                      {row.riskLevel}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-10315">
                    {getTrendIcon(row.trend)}
                  </td>
                </tr>)}
              {/* Average Row */}
              <tr className="bg-gray-100 border-t-2 border-gray-300 font-bold" data-id="element-10316">
                <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10317">
                  -
                </td>
                <td className="py-3 px-4 text-sm text-gray-900" data-id="element-10318">AVERAGE</td>
                <td className="py-3 px-4 text-sm text-gray-700" data-id="element-10319">-</td>
                <td className="py-3 px-4 text-center" data-id="element-10320">
                  <span className="inline-flex px-2.5 py-1 rounded-full text-xs font-bold bg-blue-100 text-blue-700" data-id="element-10321">
                    86.9
                  </span>
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-900" data-id="element-10322">
                  86.4
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-900" data-id="element-10323">
                  86.6
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-900" data-id="element-10324">
                  87.8
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-900" data-id="element-10325">
                  85.0
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-900" data-id="element-10326">
                  89.2
                </td>
                <td className="py-3 px-4 text-center text-sm text-green-600" data-id="element-10327">
                  87.0%
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-900" data-id="element-10328">
                  410
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-900" data-id="element-10329">
                  21d
                </td>
                <td className="py-3 px-4 text-right text-sm text-blue-600" data-id="element-10330">
                  ₹205 Cr
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10331">
                  -
                </td>
                <td className="py-3 px-4 text-center text-sm text-gray-700" data-id="element-10332">
                  -
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-10333">
          <div className="grid grid-cols-6 gap-4 text-sm" data-id="element-10334">
            <div className="text-center" data-id="element-10335">
              <div className="text-gray-600" data-id="element-10336">Total Vendors</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-10337">312</div>
            </div>
            <div className="text-center" data-id="element-10338">
              <div className="text-gray-600" data-id="element-10339">Avg Overall Score</div>
              <div className="text-xl font-bold text-blue-600" data-id="element-10340">86.9</div>
            </div>
            <div className="text-center" data-id="element-10341">
              <div className="text-gray-600" data-id="element-10342">Top Performer</div>
              <div className="text-xl font-bold text-green-600" data-id="element-10343">
                Bharat Forge
              </div>
            </div>
            <div className="text-center" data-id="element-10344">
              <div className="text-gray-600" data-id="element-10345">Avg OTD</div>
              <div className="text-xl font-bold text-green-600" data-id="element-10346">87.0%</div>
            </div>
            <div className="text-center" data-id="element-10347">
              <div className="text-gray-600" data-id="element-10348">Avg PPM</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-10349">410</div>
            </div>
            <div className="text-center" data-id="element-10350">
              <div className="text-gray-600" data-id="element-10351">High Risk Vendors</div>
              <div className="text-xl font-bold text-red-600" data-id="element-10352">3</div>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};
export default VendorPerformanceDashboard;